// extracted by mini-css-extract-plugin
module.exports = {"nav-item":"ZvLVG","shape":"jQUqw","name":"qVMfL"};